var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierraGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2814_28474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41.6C0.8 62.9333 18.4 80 40 80C62.1333 80 80 62.4 80 40.2667V0.266667C80 0.266667 80 0.266667 79.7333 0.266667C57.6 0.266667 39.7333 18.1333 39.7333 40.2667V40.5333C39.7333 40.5333 39.7333 40.5333 39.7333 40.2667C39.7333 18.1333 22.1333 0 0 0V41.6Z",
    fill: "#004B2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2814_28474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierraGreen);
export default __webpack_public_path__ + "static/media/tierra-green.9f2fe251de408140bac12d1c9efdb03a.svg";
export { ForwardRef as ReactComponent };